import { render, staticRenderFns } from "./EditResponseMedicalAdvice.vue?vue&type=template&id=2af8d9db&scoped=true"
import script from "./EditResponseMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./EditResponseMedicalAdvice.vue?vue&type=script&lang=js"
import style0 from "./EditResponseMedicalAdvice.vue?vue&type=style&index=0&id=2af8d9db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8d9db",
  null
  
)

export default component.exports